import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

/**
 * When a notification is tapped while the PWA is already open, the service worker focuses the
 * window and posts { type: 'NAVIGATE', url }. We route client-side so the session is kept.
 */
const PushNavigationListener = () => {
  const navigate = useNavigate();

  useEffect(() => {
    if (!('serviceWorker' in navigator)) return undefined;

    const onMessage = (event) => {
      const { type, url } = event.data || {};
      if (type === 'NAVIGATE' && typeof url === 'string' && url.startsWith('/') && !url.startsWith('//')) {
        navigate(url);
      }
    };

    navigator.serviceWorker.addEventListener('message', onMessage);
    return () => navigator.serviceWorker.removeEventListener('message', onMessage);
  }, [navigate]);

  return null;
};

export default PushNavigationListener;
